import angular from "angular";

angular
	.module('app')
	.component('quizResultAdminPage', {
		template: require('./quiz-result-admin-page.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
            
function controller($http) {
        
	let $ctrl = this;

	$ctrl.page = 1;
	
	$ctrl.$onInit = function () {
	    $ctrl.questions = $ctrl.resolve.questions;
        $ctrl.pageChanged();
    };

    $ctrl.goQuestion = function (index) {
        index++;
        $ctrl.page = Math.ceil(index/5);
        $ctrl.pageChanged();
    };

    $ctrl.pageChanged = function () {
        $ctrl.start = ($ctrl.page - 1) * 5 ;
    };

}